import { ReactNode } from "react";

interface SizeGuideHeadingProps {
  title: string;
  children?: ReactNode;
}

export const SizeGuideHeading = ({
  title,
  children,
}: SizeGuideHeadingProps) => {
  return (
    <div>
      <div className="text-heading-xl font-secondary text-balance mb-3 lg:mb-4">
        {title}
      </div>
      {children && <div className="pb-4 flex flex-col gap-1.5">{children}</div>}
    </div>
  );
};
